module.exports = __webpack_public_path__ + "assets/img/VideoPlayerIcon.436ed2ef-ps.png";